export default __webpack_public_path__ + "static/media/strong-4-live-class.617e99f1.jpg";